// kendo
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { process, State } from "@progress/kendo-data-query";
// api
import { GetPublicApplicationsTrackingApplicationListItemDto } from "../../../../api/Client";
// common
import ApplicationLink from "../../../../common/links/OpggsApplicationLinkView";
import * as GlobalHelpers from "../../../../common/GlobalHelpers";
import CustomGridCell from "../../../../common/kendoGrid/CustomGridCell";
import { createGridColumnFilterMenu } from "../../../../common/kendoGrid/GridColumnFilterMenu";
import { createGridColumnCheckboxFilterMenu } from "../../../../common/kendoGrid/GridColumnCheckboxFilterMenu";

interface IProps {
    listItems: GetPublicApplicationsTrackingApplicationListItemDto[];
    gridState: State;
    setGridState: (state: State) => void;
}

export default function ListView(props: IProps) {
    const { listItems, gridState, setGridState } = props;

    return (
        <Grid
            pageable
            sortable
            resizable
            navigatable
            data={process(listItems, gridState)}
            {...gridState}
            onDataStateChange={(e) => {
                setGridState(e.dataState);
            }}
        >
            <GridColumn
                field="titleNumber"
                title="Title / Name"
                cell={(props) => (
                    <CustomGridCell gridCellProps={props}>
                        {props.dataItem.titleNumber && props.dataItem.applicationId && <ApplicationLink applicationId={props.dataItem.applicationId} applicationName={props.dataItem.titleNumber} />}
                    </CustomGridCell>
                )}
                width={150}
            />
            <GridColumn field="applicationTypeName" title="Application Type" width={260} />
            <GridColumn field="titleType" title="Title Type" width={220} />
            <GridColumn field="applicantCompany" title="Applicant" width={300} filter="text" columnMenu={(p) => createGridColumnCheckboxFilterMenu(p, listItems)} />
            <GridColumn field="lodgedDate" title="Lodged Date" format={GlobalHelpers.NoptaDateFormatForKendo} filter="date" width={200} columnMenu={createGridColumnFilterMenu} />
            <GridColumn field="implementedDate" title="Implemented Date" format={GlobalHelpers.NoptaDateFormatForKendo} width={200} />
            <GridColumn field="applicationStatusName" title="Application Status" width={240} />
            <GridColumn field="offshoreAreaName" title="Offshore Area" width={285} />
        </Grid>
    );
}
